import { createApi } from '@reduxjs/toolkit/dist/query/react'
import baseQueryWithIam from '../../app/baseQueryWithIam'
import { ListResponse, PaginationState, SellerState } from '../types'

interface analysisParams {
    startDate: string
    endDate: string
    filter: string
    type?: string
}

interface fetchSellersReportParams extends analysisParams, PaginationState { }

export const sellersReportApi = createApi({
    reducerPath: 'sellersReportApi',
    baseQuery: baseQueryWithIam,
    tagTypes: ['Seller'],
    endpoints: (build) => ({
        fetchSellersReport: build.query<
            ListResponse<SellerState>,
            fetchSellersReportParams
        >({
            query: (params) => ({
                url: `/analysis/sales-managers`,
                method: 'GET',
                params,
            }),
            providesTags: (result) =>
                result
                    ? [
                        ...result.data.map(({ id }) => ({
                            type: 'Seller' as const,
                            id,
                        })),
                        { type: 'Seller', id: 'LIST' },
                    ]
                    : [{ type: 'Seller', id: 'LIST' }],
            transformResponse: (response: {
                success: boolean
                data: ListResponse<SellerState>
            }) => {
                return {
                    data: response.data.data || [],
                    pageNumber: response.data.pageNumber || 0,
                    totalCount: response.data.totalCount || 0,
                    totalPages: response.data.totalPages || 0,
                }
            },
        }),
    }),
})
